import { Divider, Grid2, Tab, Tabs } from "components";
import { useUpdateLead } from "hooks/useUpdateLead";
import DashboardLayout from "layouts/DashboardLayout";
import { useParams } from "react-router-dom";
import { TAB } from "store/slices/appSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import useDocumentTitle from "utils/useDocumentTitle";
import LeadMeeting from "../LeadMeeting";
import LeadNotes from "../LeadNotes";
import LeadCard from "./LeadCard";
import UpdateNewLead from "./UpdateNewLead";

const LeadDetail = () => {
  useDocumentTitle("Lead Details");

  const { id } = useParams<string>();

  const { leadDetailsTabs } = useAppSelector((state) => state?.app?.tab);

  const dispatch = useAppDispatch();

  const { leadData } = useUpdateLead();

  return (
    <DashboardLayout title="Lead">
      <Grid2 container spacing={1}>
        <Grid2 size={12}>
          <LeadCard leadData={leadData?.data?.data} />
        </Grid2>
        <Grid2 size={12}>
          <Tabs
            value={leadDetailsTabs}
            onChange={(e, val) => {
              dispatch(TAB({ tabKey: "leadDetailsTabs", tabValue: val }));
            }}
          >
            <Tab disableRipple label="Summary" />
            <Tab disableRipple label="Meetings" />
            <Tab disableRipple label="Notes" />
          </Tabs>
          <Divider />
        </Grid2>
        <Grid2 size={12}>
          {leadDetailsTabs === 0 && <UpdateNewLead />}
          {leadDetailsTabs === 1 && <LeadMeeting lead_id={id} />}
          {leadDetailsTabs === 2 && <LeadNotes lead_id={id} />}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default LeadDetail;
